import { Dialog } from '@economic/taco';
import { Trans, t } from '@lingui/macro';
import { Link } from 'react-router-dom';
import imgManConfused from '../../assets/man-confused.png';
import { OnboardingError, OnboardingErrorMessages } from '../../types';

interface Props {
    onboardingError: OnboardingError;
}

const OnboardingFailed = ({ onboardingError }: Props) => {
    const getErrorMessage = () => {
        const { message } = onboardingError;
        if (message === OnboardingErrorMessages.CUSTOMERPAYMENTS_CREATESETUP_GENERICERROR) {
            return t`We apologize, but a technical error occurred on our side, so unfortunately, we are unable to create the account at the moment`;
        }
        if (message === OnboardingErrorMessages.CUSTOMERPAYMENTS_VALIDATION_ERROR) {
            return t`We apologize, but an error occurred while validating your information, so unfortunately, we are unable to create the account at the moment`;
        }
        return message;
    };
    return (
        <>
            <Dialog.Title>
                <Trans>Oops! Something went wrong</Trans>
            </Dialog.Title>

            <div className="flex mt-6 justify-center">
                <img src={imgManConfused} />
            </div>

            <div className="flex flex-col mt-8">
                <strong>
                    <Trans>What is the cause of the error?</Trans>
                </strong>
                {getErrorMessage()}
            </div>

            <div className="flex mt-4">
                <span>
                    <strong>
                        <Trans>Error ID</Trans>:{' '}
                    </strong>
                    {onboardingError.value}
                </span>
            </div>

            <div className="flex flex-col mt-8">
                <strong>
                    <Trans>We're always here to help</Trans>
                </strong>
                <Trans>Please contact the e-conomics support team for help to continue at this point</Trans>
            </div>

            <div className="flex flex-col mt-8">
                <strong>
                    <Trans>E-mail:</Trans>
                </strong>
                <Link to="mailto:info@e-conomic.dk">
                    <Trans>info@e-conomic.dk</Trans>
                </Link>
            </div>

            <div className="flex flex-col mt-8">
                <strong>
                    <Trans>Phone number:</Trans>
                </strong>
                <Trans>+45 88 20 48 40</Trans>
            </div>
        </>
    );
};

export default OnboardingFailed;
